import { useQuery } from "@tanstack/react-query";
import { getUserId } from "@/helpers/common";
import { getMyPlans } from "@/services/plansService";

export const plansKey = () => ["plans", "me", getUserId()];

export const PLANS_ROOT_KEY = ["plans", "me"];

const resultOf = (response) => {
  if (response?.errorCode !== 0 || !response?.result) throw new Error(response?.message || "Could not load plans.");
  return response.result;
};

export const usePlans = (enabled = true) =>
  useQuery({
    queryKey: plansKey(),
    queryFn: async () => resultOf(await getMyPlans()),
    enabled: enabled && Boolean(getUserId()),
    staleTime: 60 * 1000,
  });

export const packageOf = (plans, key) => (plans?.packages || []).find((item) => item.key === key) || null;

export const usePackage = (key, enabled = true) => {
  const query = usePlans(enabled);
  return { ...query, pkg: packageOf(query.data, key) };
};

export const entitledFrom = (plans, feature) => {
  const entry = plans?.entitlements?.[feature];
  if (!entry || typeof entry.allowed !== "boolean") return null;
  return entry.allowed;
};

export const useEntitled = (feature, enabled = true) => {
  const query = usePlans(enabled);
  if (!query.data) return null;
  return entitledFrom(query.data, feature);
};

export const formatPlanPrice = (amount) => {
  const value = Number(amount);
  if (!Number.isFinite(value)) return null;
  return Number.isInteger(value) ? `$${value.toLocaleString("en-US")}` : `$${value.toFixed(2)}`;
};

export const perMonthOfYearly = (yearly) => (yearly ? formatPlanPrice(Math.round((Number(yearly) / 12) * 100) / 100) : null);
